import React from 'react';
import GlovalCard from '../../../../components/atoms/GlovalCard/GlovalCard';
import Button from '../../../../components/atoms/Button/Button';
import ButtonGris from '../../../../components/atoms/ButtonGris/ButtonGris';
import TextArea from '../../../../components/atoms/TextArea/TextArea';
import InputTextMy from '../../../../components/atoms/InputText/InputText';
import ModalAgregarIncidente from './ModalAgregarInciente';
import DashCard from './DashCard';
import { formateoBasico, revertirFormatoFecha } from '../../../../utilities/formateos';
const DetalleCierre = ({
    modoDetalle,
    registroSeleccionado,
    incidenciasData,
    incidenciasLoading,
    CARDS,
    onAbrirModal,
    nota,
    setNota,
    userData,
    guardando,
    onGuardar,
    onVolver,
  
}) => {

    /* Misma lógica del back: hora>=10 → ayer, hora<10 → antes de ayer */
    const getFechaTurno = () => {
        const d = new Date();
        d.setDate(d.getDate() - (d.getHours() >= 10 ? 1 : 2));
        return d.toLocaleDateString('es-MX', { day: 'numeric', month: 'long', year: 'numeric' });
    };
    return (
        <GlovalCard style={{ height: 'calc(100vh - 170px)' }}>
            {/* Encabezado */}
            <div className="detalleHeader">
                <ButtonGris onClick={onVolver} width="fit-content">
                    ← Regresar
                </ButtonGris>
                <span className="detalleTitulo">
                    {modoDetalle === 'nuevo'
                        ? 'Nuevo Cierre de Turno'
                        : `Cierre de Turno — Registro #${registroSeleccionado?.ID}`}
                </span>
                <div className="formIncidencia__fechaTurno">
                    <span>Fecha del turno</span>
                    <strong>
                        {modoDetalle === 'ver'
                            ? (registroSeleccionado?.FECHA ?? '')
                            : getFechaTurno()}
                    </strong>
                </div>
            </div>

            {/* Cards de incidencias */}
            <div className="seccionLabel">Resumen de incidencias</div>

            {incidenciasLoading && (
                <div className="cargando">
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }} />
                    <span>Cargando incidencias...</span>
                </div>
            )}

            {!incidenciasLoading && incidenciasData && (
                <>
                <div className="cardsGrid">
                    {CARDS.map((card) => {
                        /* sources: objeto con todas las fuentes de datos disponibles.
                           Para agregar una nueva fuente, añádela aquí y referencíala
                           en CardsConfig con getData: (s) => s.nuevaFuente           */
                        const sources = { incidencias: incidenciasData };
                        console.log("sources",sources);
                        
                        const datos = card.getData
                            ? card.getData(sources)
                            : (incidenciasData[card.key] ?? []);
                        return (
                            <DashCard
                                key={card.key}
                                card={card}
                                datos={datos}
                                onVerDetalle={onAbrirModal}
                            />
                        );
                    })}
                </div>
                <ModalAgregarIncidente modoDetalle={modoDetalle} />
                </>
            )}

            {/* Formulario */}
            <div className="seccionLabel" style={{ marginTop: '24px' }}>
                Datos del cierre
            </div>
            <div className="formularioCierre">
                <InputTextMy
                    title="Nombre"
                    value={
                        modoDetalle === 'ver'
                            ? (registroSeleccionado?.NOMBRE ?? '')
                            : (userData?.NOMBRE ?? '')
                    }
                    disabled
                    obligatorio={false}
                    className="campoCierre"
                />
                <div className="campoCierreFull">
                    <TextArea
                        titulo="Registro de Cierre de Turno"
                        value={nota}
                        onChange={(e) => setNota(e.target.value)}
                        disabled={modoDetalle === 'ver'}
                        placeholder={
                            modoDetalle === 'ver'
                                ? ''
                                : 'Describa el cierre de turno...'
                        }
                    />
                </div>

                {modoDetalle === 'nuevo' && (
                    <div className="accionesFormulario">
                        <Button
                            onClick={onGuardar}
                            width="fit-content"
                            disabled={guardando || !nota.trim()}
                        >
                            {guardando ? 'Guardando...' : 'Guardar'}
                        </Button>
                        <ButtonGris onClick={onVolver} width="fit-content">
                            Cancelar
                        </ButtonGris>
                    </div>
                )}

            </div>
        </GlovalCard>
    );
};

export default DetalleCierre;
